// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2669":"c132bf7d","4166":"46a4d24b","5194":"badf541d","9570":"5899e4d3"}[chunkId] || chunkId) + "." + {"2669":"1847031eea133b8f","4166":"8ab78ce0c8918335","4989":"8914bed367f2c26c","5194":"b339917682710e6f","6623":"5ea6edc642c0bac2","8490":"62630d417b0496a5","9570":"5bba71c53a878225"}[chunkId] + ".js";
};